module.exports = __webpack_public_path__ + "static/media/heatmap.f07a6a98.jpg";